import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FlashbarProps } from "@amzn/awsui-components-react/polaris";

interface NotificationState {
  notificationItems: Record<number, FlashbarProps.MessageDefinition>;
  nextIndex: number;
}

const notificationInitialState: NotificationState = {
  notificationItems: {},
  nextIndex: 0,
};

const notification = createSlice({
  name: "notification",
  initialState: notificationInitialState,
  reducers: {
    addNotification(
      state: NotificationState,
      action: PayloadAction<FlashbarProps.MessageDefinition>
    ) {
      state.notificationItems[state.nextIndex] = action.payload;
      state.nextIndex += 1;
    },
    addNotificationWithKey(
      state: NotificationState,
      action: PayloadAction<{
        key: number;
        message: FlashbarProps.MessageDefinition;
      }>
    ) {
      state.notificationItems[action.payload.key] = action.payload.message;
    },
    removeNotification(
      state: NotificationState,
      action: PayloadAction<number>
    ) {
      delete state.notificationItems[action.payload];
    },
    clearNotifications(state: NotificationState) {
      state.notificationItems = {};
    },
    setNotification(
      state: NotificationState,
      action: PayloadAction<FlashbarProps.MessageDefinition>
    ) {
      state.notificationItems = {};
      state.notificationItems[state.nextIndex] = action.payload;
      state.nextIndex += 1;
    },
  },
});

export const {
  addNotification,
  addNotificationWithKey,
  removeNotification,
  clearNotifications,
  setNotification,
} = notification.actions;

export default notification.reducer;

export function createNotificationDefinition(
  type: FlashbarProps.Type,
  header: string,
  dismissible: boolean,
  content: string
) {
  return addNotification({
    type: type,
    header: header,
    dismissible: dismissible,
    content: content,
  });
}

export function createNotificationDefinitionWithKey(
  type: FlashbarProps.Type,
  header: string,
  dismissible: boolean,
  key: number,
  content: string
) {
  return addNotificationWithKey({
    key: key,
    message: {
      type: type,
      header: header,
      dismissible: dismissible,
      content: content,
    },
  });
}
